import '../scss/about-page-style.scss';
import AboutPage from './pages/about/index';

document.addEventListener('DOMContentLoaded', () => {
  AboutPage.init();
});